export default __webpack_public_path__ + "static/GT-America-Standard-Medium-378f1b25042f29d55d7f9955bdc2e77a.woff";